import { WidgetProps } from "@rjsf/utils";
import { useMemo } from "react";

import { useGmnListAllPagesQuery } from "@/queries/query-gmn";

export const GmnSelectDropdown = ({ schema, uiSchema: _uiSchema, ...rest }: WidgetProps) => {
  const { ui: field, ...uiSchema } = _uiSchema || {};
  const { registry } = rest;
  const { data, isLoading } = useGmnListAllPagesQuery();

  const gmnOptions = useMemo(
    () =>
      [...(data?.results ?? [])]
        .sort((a, b) => a.broId.localeCompare(b.broId))
        .map((gmn) => ({ label: gmn.broId, value: gmn.broId })),
    [data]
  );

  const { EnumOrInput } = registry.widgets;

  return (
    <EnumOrInput
      {...rest}
      isLoading={isLoading}
      schema={{
        ...schema,
        enum: gmnOptions.map((option) => option.value),
      }}
      uiSchema={{
        ...uiSchema,
        "ui:enumNames": gmnOptions.map((option) => option.label),
      }}
    />
  );
};
